const buildEnv = import.meta.env || {};
const assetOrigin = String(buildEnv.VITE_ASSET_ORIGIN || "").replace(/\/$/, "");
const useEmbeddedAssets = buildEnv.VITE_FREESTORE_EMBED === "1";

export function assetUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (useEmbeddedAssets && typeof window !== "undefined") {
    return window.__MEDEIN_ASSETS?.[normalizedPath] || normalizedPath;
  }

  if (!assetOrigin) return normalizedPath;
  return `${assetOrigin}${normalizedPath}`;
}
